export const LAWLEXAU = 'lawlexau';
export const LAWLEXEU = 'lawlexeu';
export const LAWLEXUS = 'lawlexus';